module.exports = __webpack_public_path__ + "img/pick-hub-illustration.cba6045f.svg";